import axios from 'axios';
const API_PREFIX = process.env.REACT_APP_API_PREFIX;
export const getAll = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');
  return await axios
    .get(`${API_PREFIX}/exams${filter}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const getExamStatus = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');
  return await axios
    .get(`${API_PREFIX}/exams/getExamStatus/getExamStatus${filter}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const getExamStatusAdmin = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');
  return await axios
    .get(`${API_PREFIX}/exams/getExamStatus/getExamStatusAdmin${filter}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};

export const getOne = async (id) => {
  return await axios
    .get(`${API_PREFIX}/exams/${id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const create = async (payload) => {
  return await axios
    .post(`${API_PREFIX}/exams`, payload)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const update = async (id, payload) => {
  return await axios
    .put(`${API_PREFIX}/exams/${id}`, payload)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const remove = async (id) => {
  return await axios
    .delete(`${API_PREFIX}/exams/${id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const getAllExamDates = async (id, rrb = false) => {
  if (rrb) {
    return await axios
      .get(`${API_PREFIX}/exams/dates/${id}?rrb=${rrb}`)
      .then((res) => {
        return res.data;
      })
      .catch((error) => Promise.reject(error?.response.data));
  }
  return await axios
    .get(`${API_PREFIX}/exams/dates/${id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};

export const getExamReport = async (id) => {
  return await axios
    .get(`${API_PREFIX}/exams/report/${id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};

export const getExamStatusPerfoma = async (param, extra = '') => {
  console.log('param', param);
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');
  return await axios
    .get(`${API_PREFIX}/exams/getExamStatus/getExamStatusPerfoma${filter}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
